import { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { T } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faShoppingCart } from "@fortawesome/free-solid-svg-icons";

const CartButtons = ({ cart, setSummary, onSave, confirmToRequest, cartReset }) => {
    const [cancelSize, setCancelSize] = useState(6);
    const [continueSize, setContinueSize] = useState(6);

    useEffect(() => {
        checkSize(cart);
    }, [cart]);

    const checkSize = (cart) => {
        const hasPreferences = cart?.items?.some(item => item.preferences && Object.keys(item.preferences).length > 0) ;
        if (hasPreferences) {
            setCancelSize(4);
            setContinueSize(8);
        } else {
            setCancelSize(6);
            setContinueSize(6);
        }
        console.log("hasPreferences", hasPreferences)
    };

    return (
        <Row className="mb-3">
            <Col xs={cancelSize} className="pr-1">
                <Button
                    size={"lg"}
                    variant={"primary"}
                    type={"button"}
                    block={true}
                    className={"cart-cancel"}
                    onClick={cartReset}
                >
                    <FontAwesomeIcon
                        className="mr-2"
                        style={{ color: "#FFF" }}
                        icon={faTimesCircle}
                    />
                    {T("general.cancel")}
                </Button>
            </Col>
            <Col xs={continueSize} className="pl-1">
                <Button
                    size={"lg"}
                    variant={"success"}
                    type={"button"}
                    block={true}
                    className={"cart-go-resume"}
                    onClick={() => {
                        if (confirmToRequest) {
                            setSummary(true);
                            //setOpenModal(true)
                        } else {
                            onSave();
                        }
                    }}
                >
                    <FontAwesomeIcon
                        className="mr-2"
                        style={{ color: "#FFF" }}
                        icon={faShoppingCart}
                    />
                    {continueSize === 8 ? T("request.continue_customize") : T("general.continue")}
                </Button>
            </Col>
        </Row>
    );
};

export default CartButtons;
